/** 大陸上市通道（Overseas patch 268） */
export const CN_MARKET_CHANNEL_MENU_IDS = {
  group: 990485,
  desk: 990486,
  view: 990487,
  gate: 990488,
  signup: 990489,
  signupGate: 990490
}

export default CN_MARKET_CHANNEL_MENU_IDS



// WEBPACK FOOTER //
// ./src/constants/cnMarketChannel.js